import { useState } from "react";
import type { ProcessedCourse } from "@/common/course/types";
import useTranslations from "@/i18n/useTranslations";

type ProgramCoursesProps = {
  courses: ProcessedCourse[];
};

export default function ProgramCourses({ courses }: ProgramCoursesProps) {
  const tExpand = useTranslations("ExpandableBlock");
  const tCourse = useTranslations("Course");
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-putty-100 border rounded-[8px] shadow w-full max-w-md mx-auto bg-white">
      <h2 className="text-md font-semibold text-white bg-[#1f453d] rounded-t-[8px] py-2 px-4 my-0">
        {tCourse("coursesInThisProgramCount", { count: courses.length })}
      </h2>
      <div className="p-4">
        <ul className="list-disc pl-5 text-base font-bold">
          {courses.map((course, index) => (
            <li
              key={index}
              className={`mb-2 text-md
            ${!isExpanded && index > 1 ? "hidden" : ""}`}
            >
              {course.productName}
            </li>
          ))}
        </ul>

        {courses.length > 2 && (
          <div
            className={`
            flex
            ${courses.length <= 2 ? "hidden" : ""} 
          `}
          >
            <span
              className="underline cursor-pointer"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {!isExpanded ? tExpand("showMore") : tExpand("showLess")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
